// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"d758fc9b","237":"b45506a4","324":"ba21542b","425":"e468e73a","499":"bcd53159","576":"789074c8","827":"101d3c1d"}[chunkId] + ".chunk.js";
};